// @ts-nocheck
import { CASE_UPLOAD_FILE_ERROR, CASE_UPLOAD_FILE_LOADING, CASE_UPLOAD_FILE_SUCCESS} from "../../Action/Type";

const initialState = {
    payload: {},
    loading: false,
    error: ''
}

export const CaseUploadFileReducer = (state = initialState, action) => {
    switch (action.type) {
        case CASE_UPLOAD_FILE_LOADING:
            return Object.assign({}, state, { loading: true })
        case CASE_UPLOAD_FILE_SUCCESS:
            return Object.assign({}, state, { payload: action.data, loading: false })
        case CASE_UPLOAD_FILE_ERROR:
            return Object.assign({}, state, { payload: action.data, loading: false })
        default:
            return state
    }
}

